import {axiosWeb} from "@/js/axios";

const state = {
    ads: [],

    // Flags
    fetchingAds: false,
};

const getters = {
    ads: (state) => {
        return state.ads;
    },
    fetchingAds: () => state.fetchingAds
};

const actions = {
    fetchAds({commit}) {
        commit('SET_FETCHING_ADS', true);

        return new Promise((resolve, reject) => {
            axiosWeb.get(`/api/v1/user-a-subs`)
                .then(({data}) => {
                    commit('SET_FETCHING_ADS', false);
                    commit('SET_ADS', data);
                    return resolve(data);
                })
                .catch(error => {
                    commit('SET_FETCHING_ADS', false);
                    reject(error);
                })
        });
    },

};

const mutations = {
    SET_ADS(state, data) {
        state.ads = data;
    },

    SET_FETCHING_ADS(state, value) {
        state.fetchingAds = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/adverts.js